<script lang="ts" setup>
import { useRuntimeConfig } from '#app'
import { EVENT } from '~/configs/page-url'

const { isMobile } = useDevice()
const route = useRoute()
const router = useRouter()
const isShowFloating = ref(true)
const { EVENT_PREMIER_LEAGUE_RANKING_ENABLED } = useRuntimeConfig().public

const redirectToEvent = () => {
  router.push(EVENT.HALLOWEEN)
  isShowFloating.value = false
}

const closeFloating = () => {
  isShowFloating.value = false
}

watch(
  () => route.path,
  (value: string) => {
    isShowFloating.value = value !== EVENT.HALLOWEEN
  },
  { immediate: true },
)
</script>
<template>
  <div
    v-if="isShowFloating"
    :class="[
      'event-halloween-floating',
      {'mobile': isMobile},
      {'is-event-premier-league': EVENT_PREMIER_LEAGUE_RANKING_ENABLED}
    ]"
  >
    <div class="button-close" @click="closeFloating">
      <img
        src="/assets/images/events/halloween/floating/icon-float-close.webp"
        alt="Close"
      >
    </div>
    <img
      class="button-floating__thumb"
      src="/assets/images/events/halloween/floating/icon-float.webp"
      alt="Floating"
      @click="redirectToEvent"
    />
  </div>
</template>
<style lang="scss">
@import '~/assets/scss/components/common/event/halloween/floating.scss';
</style>
